import {Component, ElementRef, Input} from '@angular/core';
import {WebsiteSpotPage} from '../../website-spot';

@Component({
    selector: 'cp-logotipo',
    templateUrl: 'cp-logotipo.html',
    providers: []
})
export class CpLogotipo {

    //@Input('hpage') hpage: WebsiteSpotPage;

    @Input('hpage')
    set hpageSet(data: WebsiteSpotPage) {

        this.hpage = data;

        let feedback = this.hpage.rootdata.Hotspots[0].Branded.BrandedBody.Hspot.Feedback;
        this.feedback = (feedback == this.hpage.THotpageFeedback.hfLogotipo);

    }

    logobool: boolean;

    feedback: boolean;
    hpage: WebsiteSpotPage;

    constructor(public element: ElementRef) {

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/website-spot/components/cp-logotipo/cp-logotipo.ts